import { List } from '@material-ui/core';
import { IconProp } from 'app/AllIcons';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import { Roles } from 'app/slice/types';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// import styled from 'styled-components';
// import { verticalScrolling } from 'styles/CssVariables/styledVariables';
import { AuthenticatedUser, isInRole } from 'types/AuthenticatedUser';
import {
  MainTabsUnion,
  SiteMapNode,
  SiteMapProvider,
} from 'types/SiteMapSettings';
import { isNullOrUndefined } from 'utils/typeUtils';
import { createMenuItemRefs } from './HoverMenu';
import SidbarMenuItem, { SidebarMenuItemProps } from './MenuItem';
import clsx from 'clsx';
import { groupBy, values } from 'lodash';
import styled from 'styled-components';
import { verticalScrolling } from 'styles/CssVariables/styledVariables';
import { selectRouterPathname } from 'app/slice/router-selectors';

export interface SideBarMenuItemProps {
  menuItems: SiteMapNode[];
  currentIndex?: number;
  currentNode?: SiteMapNode | undefined;
  isOpen: boolean;
  loading: boolean;
  isMobile?: boolean;
}
const NavWrapper = styled('div')`
  height: calc(100% - 50px);
  overflow-y: auto;
  width: 100%;
  overflow-x: hidden;
  ${verticalScrolling}
`;
const MainMenuItem = styled('div')`
  &.mainMenuItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    &.mainMenuItemExpanded {
      align-items: flex-start;
      align-self: stretch;
    }
    &.mainMenuItemCollapsed {
      align-items: center;
    }
  }
`;
const replaceIcon = (icon: string): IconProp => {
  if (icon.indexOf(' fa-') !== -1) {
    let tmpIcon = icon.substring(icon.indexOf(' fa-') + 4, icon.length);
    return tmpIcon as IconProp;
  }
  return icon as IconProp;
};
const convertUrl = (url: string): string => {
  if (url !== null) {
    if (url.indexOf(process.env.PUBLIC_URL) !== -1) {
      return url.replace(process.env.PUBLIC_URL, '');
    }
    return url;
  }
  return url;
};
export const getAdminNodeSettings = (
  item: SiteMapNode,
  siteMapProvider: SiteMapProvider,
  user?: AuthenticatedUser,
): SidebarMenuItemProps[] => {
  let result: SidebarMenuItemProps[] = [];
  const isAdmin =
    isInRole(user, Roles.Administrators) ||
    isInRole(user, Roles.GroupAdministrators) ||
    isInRole(user, Roles.EquipmentAdministrator) ||
    isInRole(user, Roles.CustomRole);
  if (
    isAdmin &&
    item.ChildNodes.length > 0 &&
    !!item.MainTab &&
    item.ChildNodes.some(f => f.IsAdminSettings)
  ) {
    let filtered = item.ChildNodes.filter(
      f => f.IsAdminSettings && siteMapProvider.nodeAccesibleByRole(f, user),
    ).map((it, index) => {
      return {
        name: it.Title,
        link: it.reactUrl ?? convertUrl(it.Url),
        Icon: isNullOrUndefined(it.icon) ? undefined : (
          <Icon icon={replaceIcon(it.icon)} />
        ),
        items: [] as SidebarMenuItemProps[],
        external: isNullOrUndefined(it.reactUrl),
        index: index,
        selected: false,
      } as SidebarMenuItemProps;
    });
    return filtered;
  }
  return result;
};

export function SideBarMenu(props: SideBarMenuItemProps) {
  // const classes = useStyles({ isOpen: props.isOpen });
  const location = useLocation();
  const routerPathName = useSelector(selectRouterPathname);
  const { menuItems, currentIndex, currentNode, isOpen, isMobile } = props;
  const [selectedIndex, setSelectedIndex] = React.useState(currentIndex || -1);
  // const [mapItems, setMapItems] = React.useState<SidebarMenuItemProps[]>([]);
  const mapItems = React.useMemo(() => {
    return menuItems.map((item, index) => {
      const link: string | null | undefined =
        item.ChildNodes.filter(
          ch => ch.HideReact === false && ch.Hide === false,
        ).length > 0
          ? item.LinkWithChildren ?? null
          : item.reactUrl ?? convertUrl(item.Url);
      return {
        name: item.Title,
        link: link,
        Icon: isNullOrUndefined(item.icon) ? undefined : (
          <Icon icon={replaceIcon(item.icon)} size="lg" />
        ),
        items:
          item.ChildNodes.filter(
            ch => ch.HideReact === false && ch.Hide === false,
          ).length > 0
            ? item.ChildNodes.filter(citem => {
                // filter to exclude '/usertraininghistory' url from sidebar
                return citem.HideReact === false && citem.Hide === false;
              }).map((chItem, chIndex) => {
                return {
                  name: chItem.Title,
                  link: chItem.reactUrl ?? convertUrl(chItem.Url),
                  Icon: isNullOrUndefined(chItem.icon) ? undefined : (
                    <Icon icon={replaceIcon(chItem.icon)} />
                  ),
                  items: [] as SidebarMenuItemProps[],
                  external: isNullOrUndefined(chItem.reactUrl),
                  index: chIndex,
                  selected:
                    location.pathname
                      .toLowerCase()
                      .indexOf(
                        (chItem.reactUrl ?? chItem.Url).toLowerCase(),
                      ) !== -1 ||
                    (!!routerPathName &&
                      routerPathName
                        .toLowerCase()
                        .indexOf(
                          (chItem.reactUrl ?? chItem.Url).toLowerCase(),
                        ) !== -1),
                };
              })
            : ([] as SidebarMenuItemProps[]),
        hasAdminSettings: item.ChildNodes.some(f => f.IsAdminSettings === true),
        mainTab: !!item.MainTab ? (item.MainTab as MainTabsUnion) : undefined,
        groupTab: item.GroupTab,
        external:
          link?.includes('aspx') ||
          (isNullOrUndefined(item.reactUrl) &&
            item.ChildNodes.filter(
              ch => ch.HideReact === false && ch.Hide === false,
            ).length === 0),
        index: index,
        selected:
          currentNode === undefined
            ? false
            : selectedIndex === -1
            ? currentNode.Key === item.Key
            : selectedIndex === index,
        closeOnClick:
          !isNullOrUndefined(item.LinkWithChildren) ||
          item.ChildNodes.filter(
            ch => ch.HideReact === false && ch.Hide === false,
          ).length < 1,
      };
    });
  }, [
    currentNode,
    location.pathname,
    menuItems,
    routerPathName,
    selectedIndex,
  ]);
  // const isAdmin =
  //   isInRole(authenticatedUser, Roles.Administrators) ||
  //   isInRole(authenticatedUser, Roles.GroupAdministrators) ||
  //   isInRole(authenticatedUser, Roles.EquipmentAdministrator);
  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };
  React.useEffect(() => {
    if (!!currentNode) {
      const idx = menuItems.findIndex(f => f.Key === currentNode.Key);
      if (idx !== -1) {
        setSelectedIndex(idx);
      }
    }
  }, [currentNode, menuItems]);
  // React.useEffect(() => {
  //   setMapItems(
  //     menuItems.map((item, index) => {
  //       const link: string | null | undefined =
  //         item.ChildNodes.filter(
  //           ch => ch.HideReact === false && ch.Hide === false,
  //         ).length > 0
  //           ? item.LinkWithChildren ?? null
  //           : item.reactUrl ?? convertUrl(item.Url);
  //       return {
  //         name: item.Title,
  //         link: link,
  //         Icon: isNullOrUndefined(item.icon) ? undefined : (
  //           <Icon icon={replaceIcon(item.icon)} size="lg" />
  //         ),
  //         items:
  //           item.ChildNodes.filter(
  //             ch => ch.HideReact === false && ch.Hide === false,
  //           ).length > 0
  //             ? item.ChildNodes.filter(citem => {
  //                 // filter to exclude '/usertraininghistory' url from sidebar
  //                 return citem.HideReact === false && citem.Hide === false;
  //               }).map((chItem, chIndex) => {
  //                 return {
  //                   name: chItem.Title,
  //                   link: chItem.reactUrl ?? convertUrl(chItem.Url),
  //                   Icon: isNullOrUndefined(chItem.icon) ? undefined : (
  //                     <Icon icon={replaceIcon(chItem.icon)} />
  //                   ),
  //                   items: [] as SidebarMenuItemProps[],
  //                   external: isNullOrUndefined(chItem.reactUrl),
  //                   index: chIndex,
  //                   selected:
  //                     location.pathname
  //                       .toLowerCase()
  //                       .indexOf(
  //                         (chItem.reactUrl ?? chItem.Url).toLowerCase(),
  //                       ) !== -1 ||
  //                     (!!routerPathName &&
  //                       routerPathName
  //                         .toLowerCase()
  //                         .indexOf(
  //                           (chItem.reactUrl ?? chItem.Url).toLowerCase(),
  //                         ) !== -1),
  //                 };
  //               })
  //             : ([] as SidebarMenuItemProps[]),
  //         hasAdminSettings: item.ChildNodes.some(
  //           f => f.IsAdminSettings === true,
  //         ),
  //         mainTab: !!item.MainTab ? (item.MainTab as MainTabsUnion) : undefined,
  //         groupTab: item.GroupTab,
  //         external:
  //           link?.includes('aspx') ||
  //           (isNullOrUndefined(item.reactUrl) &&
  //             item.ChildNodes.filter(
  //               ch => ch.HideReact === false && ch.Hide === false,
  //             ).length === 0),
  //         index: index,
  //         selected:
  //           currentNode === undefined
  //             ? false
  //             : selectedIndex === -1
  //             ? currentNode.Key === item.Key
  //             : selectedIndex === index,
  //         closeOnClick:
  //           !isNullOrUndefined(item.LinkWithChildren) ||
  //           item.ChildNodes.filter(
  //             ch => ch.HideReact === false && ch.Hide === false,
  //           ).length < 1,
  //       };
  //     }),
  //   );
  // }, [
  //   authenticatedUser,
  //   location.pathname,
  //   menuItems,
  //   currentNode,
  //   selectedIndex,
  //   siteMapProvider,
  //   routerPathName,
  // ]);
  const menuItemRefs = React.useRef(
    createMenuItemRefs(menuItems, currentIndex ?? 0),
  );
  return (
    <NavWrapper>
      <List
        component="nav"
        className={clsx('sideBarList', {
          sideBarExpanded: isOpen,
          sideBarCollapsed: !isOpen,
          sideBarListMobile: isMobile,
        })}
        role="menubar"
        disablePadding
      >
        {values(groupBy(mapItems, f => f.groupTab)).map((f, key) => {
          return (
            <div className={'sideBarListGroup'} key={key}>
              {f.map((item, index) => (
                <MainMenuItem
                  className={clsx('mainMenuItem', {
                    mainMenuItemExpanded: isOpen,
                    mainMenuItemCollapsed: !isOpen,
                  })}
                  key={index}
                >
                  <SidbarMenuItem
                    {...item}
                    key={item.index}
                    selected={
                      selectedIndex === -1
                        ? item.selected
                        : selectedIndex === item.index
                    }
                    ref={element =>
                      (menuItemRefs.current[item.index] = element)
                    }
                    indexChanged={handleListItemClick}
                  />
                </MainMenuItem>
              ))}
            </div>
          );
        })}
      </List>
    </NavWrapper>
  );
}
